import axios from "../../../../../utils/axiosInceptor";
import * as action_types from "./constants";
import { authService, maintenanceService } from "../../../../../configs/constants";
const zonelistUrl = `${maintenanceService}/facilityManager/fetchZones`;
const getTechniciansUrl = `${maintenanceService}/serviceprovider/technician`;

//  for cleaning filters params or any api params

function cleanFilterParams(filter) {
  return Object.fromEntries(
    Object.entries(filter)
      .filter(([_, v]) => v != null) // remove null/undefined
      .map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]) // trim string values
      .filter(([_, v]) => v !== '') // remove empty strings after trim
  );
}

export const getAllZones = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(zonelistUrl);
      dispatch({
        type: action_types.GET_ZONES_LIST,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};




export const getAllTechnicians = (page, limit, filter,setLoading=null) => {

  const cleaned:any = cleanFilterParams(filter);
   let params = new URLSearchParams(cleaned);
  return async (dispatch) => { 
    setLoading && setLoading(true);
    const url = `${getTechniciansUrl}?perPage=${limit}&page=${page}&`+params.toString();
    try {
      const {
        data: { result },
      } = await axios.get(url);

     (result && setLoading) && setLoading(false);
      dispatch({
        type: action_types.GET_TECH_LIST,
        data: result,
      });
    } catch (e) {
      (setLoading) && setLoading(false);
      console.log("Err", e);
    }
  };
};

export const invite = async (payload, message) => {
  try {
    const url = `${authService}/user/sendInvite`;
    const { status } = await axios.post(url, payload, {
      headers: { application: 4 },
    });
    
    return status;

  } catch (error) {}
};

export const getMaintananceCategories = (page = 1) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/maintenance/category`);
      
      dispatch({
        type: action_types.GET_MAINTANANCE_CATEGORIES,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getNewMaintananceCategories = (page = 1) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/serviceprovider/detail`);
      
      dispatch({
        type: action_types.GET_NEW_MAINTANANCE_CATEGORIES,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getTechniciansForServiceProviders = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/maintenance/technician/dropdown`);
      
      dispatch({
        type: action_types.GET_SP_TECHNICIANS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};


